export default {"src":"/_next/static/media/audio-dark.88216ab8.svg","height":100,"width":100};